//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { WestfieldDirectMediumSVG } from './svg'

interface WestfieldDirectMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const WestfieldDirectMediumIcon: React.FC<WestfieldDirectMediumIconProps> = forwardRef<
  WestfieldDirectMediumIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={WestfieldDirectMediumSVG}
    sx={sx}
  />
))
